module.exports = __webpack_public_path__ + "img/zxs.3d09c510.jpg";